import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CancelButton from "../../../../components/CancelButton";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import EditButton from "../../../../components/EditButton";
import ScriptTextAreaHookForm from "../../../../components/ScriptTextAreaHookForm";
import SubmitHookForm from "../../../../components/SubmitHookForm";
import { toast } from "../../../../components/toastNotification";
interface ScriptFormProps {
  content;
  setIsShow;
  actionAddState: boolean;
  setIsScriptSave;
  setContent;
}
const ScriptForm: React.FC<ScriptFormProps> = ({
  content,
  setIsShow,
  actionAddState,
  setIsScriptSave,
  setContent,
}) => {
  const useFormMethods = useForm();
  const { handleSubmit, setValue, watch, register } = useFormMethods;
  const [saveModal, setSaveModal] = useState(false);
  const [isView, setisView] = useState(true);
  const [IsEditScript, setIsEditScript] = useState(false);

  useEffect(() => {
    setValue("script", content);
  }, []);

  const handleCancel = () => {
    if (IsEditScript) {
      setIsEditScript(false);
      setisView(true);
      setValue("script", content);
    } else {
      setIsShow(false);
    }
  };
  const onSubmit = (data) => {
    if (IsEditScript) {
      if (actionAddState) {
        setSaveModal(true);
      } else {
        const oldScriptContent = JSON.stringify(content);
        const newScriptContent = JSON.stringify(data.script);
        if (oldScriptContent === newScriptContent) {
          toast.fire("Saving Failed", "No Changes have been made", "warning");
        } else {
          setSaveModal(true);
        }
      }
    }
  };
  const handleSave = () => {
    setIsEditScript(false);
    setisView(true);
    setSaveModal(false);
    setContent(watch("script"));
    setIsScriptSave(true);
    toast.fire("Success", "Script Updated Successfully", "success");
  };
  return (
    <>
      <>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-1 mt-2">
            <div className="font-bold text-primary text-base">SCRIPT</div>
            <div className="flex justify-between gap-2">
              {IsEditScript && (
                <SubmitHookForm
                  type="submit"
                  disabled={false}
                  buttonText={false ? "Saving.." : "Save"}
                  className={undefined}
                  onClick={undefined}
                />
              )}
              {!IsEditScript && (
                <EditButton
                  disabled={false}
                  className={"opacity-100"}
                  onClick={() => {
                    setIsEditScript(true);
                    setisView(false);
                  }}
                />
              )}
              <CancelButton
                onClick={() => {
                  handleCancel();
                }}
              />
            </div>
          </div>

          <div className="bg-bgDB py-4 space-y-4 border-gray-700">
            <ScriptTextAreaHookForm
              label=""
              className="text-lg sm:text-lg border-2 border-gray-200"
              secondDiv="grid grid-cols-1"
              required={false}
              disabled={false}
              rows={12}
              register={register("script", {})}
              readOnly={isView}
            />
          </div>
        </form>
      </>
      <ConfirmBoxModal
        ModalTitle={"Update script"}
        qConfirmation={`Are you sure you want to update this script?`}
        isOpen={saveModal}
        onClose={() => {
          setSaveModal(false);
        }}
        onClickFunction={() => {
          handleSave();
        }}
        cancelButtonRef={undefined}
      />
    </>
  );
};

export default ScriptForm;
